export interface TabItem {
  id: string;
  label: string;
  /** Getal achter het label, bijvoorbeeld hoeveel er openstaat. */
  aantal?: number;
}

/** Gelijk aan de tabs in Wagenpark; verandert het daar, dan hier ook. */
export function Tabs({
  items,
  value,
  onChange,
}: {
  items: TabItem[];
  value: string;
  onChange: (id: string) => void;
}) {
  return (
    <div className="vs-tabs" role="tablist">
      {items.map((it) => (
        <button
          key={it.id}
          role="tab"
          type="button"
          aria-selected={value === it.id}
          className="vs-tab"
          onClick={() => onChange(it.id)}
        >
          {it.label}
          {it.aantal !== undefined && <span className="vs-tab__aantal">{it.aantal}</span>}
        </button>
      ))}
    </div>
  );
}
